import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { ReactComponent as SuccesslIcon } from 'applicaiton/assets/success-icon.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';

interface SuccessModalProps {
  name: string;
  onClose: () => void;
}

const SuccessModal: FC<SuccessModalProps> = ({ name, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal open={true}>
      <StyledModal>
        <CloseIcon onClick={onClose} />
        <div>
          <SuccesslIcon />
          <p>
            {t('clinic_owner.modal_success.title_part1')} <span>{name}</span>{' '}
            {t('clinic_owner.modal_success.title_part_update')}
          </p>
          <SecondaryButton onClick={onClose}>
            {t('clinic_owner.modal_success.ok')}
          </SecondaryButton>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default SuccessModal;
